import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {
	
	// ---------- 菜单 ----------
	menu_collection: [{		//收藏菜单
		title:"职员管理",
		muid:'1',
		m_url:"http://posstaff.ailend.hk/#/?"
	},{
		title:"商品入库",
		muid:'2',
		m_url:"http://poslogin.ailend.hk/#/ShopWarehousing?"
	},{
		title:"礼品入库",
		muid:'3',
		m_url:"http://poslogin.ailend.hk/#/lipinWarehousing?"
	},{
		title:"仓库设置",
		muid:'4',
		m_url:"http://poslogin.ailend.hk/#/WarehouseSetting?"
	},{
		title:"柜台设置",
		muid:'5',
		m_url:"http://poslogin.ailend.hk/#/CounterSetting?"
	},{
		title:"其他入库设置",
		muid:'6',
		m_url:"http://poslogin.ailend.hk/#/OtherWareheouse?"
	},{
		title:"柜组设置",
		muid:'7',
		m_url:"http://poslogin.ailend.hk/#/CabinetSetting?"
	},{
		title:"商品历史库存",
		muid:'8',
		m_url:"http://poslogin.ailend.hk/#/goodsHistoryKC?"
	},{
		title:"商品库存",
		muid:'9',
		m_url:"http://poslogin.ailend.hk/#/goodsKC?"
	},{
		title:"玉珠库存",
		muid:'10',
		m_url:"http://poslogin.ailend.hk/#/yuzhuKC?"
	},{
		title:"旧料库存",
		muid:'11',
		m_url:"http://poslogin.ailend.hk/#/jiuliaoKC?"
	},{
		title:"礼品库存",
		muid:'12',
		m_url:"http://poslogin.ailend.hk/#/giftKC?"
	},{
		title:"商品调价",
		muid:'13',
		m_url:"http://poslogin.ailend.hk/#/goodsChangePrice?"
	},{
		title:"商品盘点",
		muid:'14',
		m_url:"http://poslogin.ailend.hk/#/goodsPanDian?"
	},{
		title:"玉珠盘点",
		muid:'15',
		m_url:"http://poslogin.ailend.hk/#/yuzhuPanDian?"
	},{
		title:"商品调拨",
		muid:'16',
		m_url:"http://poslogin.ailend.hk/#/goodsDiaoBo?"
	},{
		title:"礼品调拨",
		muid:'17',
		m_url:"http://poslogin.ailend.hk/#/giftDiaoBo?"
	},{
		title:"旧料转新",
		muid:'18',
		m_url:"http://poslogin.ailend.hk/#/jiuLiaoZhuanXin?"
	},{
		title:"玉珠调拨",
		muid:'19',
		m_url:"http://poslogin.ailend.hk/#/yuzhuDiaoBo?"
	},{
		title:"商品下柜",
		muid:'20',
		m_url:"http://poslogin.ailend.hk/#/goodsXiaGui?"
	},{
		title:"旧料下柜",
		muid:'21',
		m_url:"http://poslogin.ailend.hk/#/jiuliaoXiaGui?"
	},{
		title:"礼品下柜",
		muid:'22',
		m_url:"http://poslogin.ailend.hk/#/lipinXiaGui?"
	},{
		title:"商品下柜",
		muid:'23',
		m_url:"http://poslogin.ailend.hk/#/yuzhuXiaGui?"
	},{
		title:"销售查询",
		muid:'24',
		m_url:"http://poslogin.ailend.hk/#/Sales?"
	},{
		title:"新货销售",
		muid:'25',
		m_url:"http://poslogin.ailend.hk/#/SalesCash?"
	},{
		title:"销售明细",
		muid:'26',
		m_url:"http://poslogin.ailend.hk/#/SalesDetail?"
	},{
		title:"售后政策设置",
		muid:'27',
		m_url:"http://poslogin.ailend.hk/#/Policy?"
	},{
		title:"折扣率设置",
		muid:'28',
		m_url:"http://poslogin.ailend.hk/#/Discount?"
	},

	],
	
	
	
	
	//---------- 移动主页 ----------
	moveboxshow:true,		//移动主页显示与否
	editableTabsValue2: '1',	//选项卡选中
	editableTabs2: [		//移动主页数据内容
// 		{		
// 			title: 'Tab 1',
// 			name: 1,
// 			url: 'http://www.baidu.com'
// 		}, {
// 			title: 'Tab 2',
// 			name: 2,
// 			url: 'http://game.163.com'
// 		},
	],
	editableTab_index:1,
	iframe_loading:false,
	
	
}

const mutations = {
	
}

const actions = {
	// getmenudata:function(context,mdata){
	// 	console.log("54545656565456",mdata.name);
	// 	var freamid = 'iframepage'+ mdata.name
	// 	// console.log(document.getElementById(freamid));
	// 	var iframe = document.getElementById(freamid).contentWindow;
	// 	iframe.postMessage(API.IPHONE_TOKEN,"*");
	// }
}

export default new Vuex.Store({
	state,
	mutations,
	actions
});


// WEBPACK FOOTER //
// ./src/store/store.js